<i18n>
{
  "en": {
    "hello": " Verification System",
    "label": {
      "mail": "Email",
      "postEmail": "Send a password change email"
    },
    "passwordForget": {
      "intro": "If you forgot your password, click ",
      "here": "here"
    },
    "inquiry": {
      "intro": "If you can not login, please contact us from ",
      "here": "here",
      "inquiry": ""
    },
    "inquiry1": "",
    "inquiry2": "here",
    "inquiry3": "",
    "maintenance": {
      "inMaintenance": "Currently under system maintenance. <br /> Sorry for your inconvenience, but please access again after the maintenance is completed.",
      "maintenance": "Due to system maintenance, the service will be suspended for the following period.",
      "stopTerm": "[Stop period]",
      "notice": "*Depending on the maintenance work situation, it may be extended."
    }
  },
  "ja": {
    "hello": "手続きシステムへようこそ！",
    "label": {
      "mail": "メールアドレス",
      "postEmail": "パスワード変更用のメールを送信する"
    },
    "passwordForget": {
      "intro": "パスワードを忘れた方は",
      "here": "こちら"
    },
    "inquiry": {
      "intro": "※ログインできない場合は",
      "here": "よくある質問",
      "inquiry": "からお問い合わせください。"
    },
    "maintenance": {
      "inMaintenance": "現在、システムメンテナンス中です。<br />お手数ですが、メンテナンス終了後に再度アクセスしてください。",
      "maintenance": "システムメンテナンスのため、下記期間サービスを停止致します。",
      "stopTerm": "【停止期間】",
      "notice": "※メンテナンス作業の状況によっては、延長させて頂く場合がございます。"
    }
  }
}
</i18n>

<template>
  <div>
    <Toolbar :title="campaign.name + $t('hello')" />
    <v-container>
      <v-flex
        style="justify-content: center;
          text-align: center;
          margin-top: 16px;
          margin-bottom: 16px;"
      >
        <img src="@/assets/title.png" />
      </v-flex>

      <v-layout
        row
        wrap
        align-center
        justify-center
        pt-1
        v-if="isMaintenanceSchedule"
      >
        <div class="maintenance">
          <span v-if="isMaintenance">
            <strong v-html="$t('maintenance.inMaintenance')"></strong>
          </span>
          <span v-else>
            <strong>{{ $t('maintenance.maintenance') }}</strong>
          </span>
          <br />
          {{ $t('maintenance.stopTerm') }}{{ maintenanceTerm }}<br />
          <small>({{ $t('maintenance.notice') }})</small>
        </div>
      </v-layout>

      <v-layout row wrap align-center justify-center pt-5 v-if="!isMaintenance">
        <v-flex text-xs-center xs12 sm12 md8 lg8>
          <EmailSigninForm :onSubmit="signup" :changeEmailMethod="postEmail" />

          <v-btn flat @click="passwordChangeDialog = true">{{
            $t('passwordForget.intro') + $t('passwordForget.here')
          }}</v-btn>

          <br />
          <p class="body-2">
            {{ $t('inquiry.intro') }}
            <a
              :href="`/cp/${this.$route.params.campaignCode}/me/help`"
              target="_blank"
              >{{ $t('inquiry.here') }}
            </a>
            {{ $t('inquiry.inquiry') }}
          </p>

          <v-dialog v-model="passwordChangeDialog" scrollable max-width="600px">
            <v-card>
              <v-card-text>
                <v-container fluid>
                  <v-layout text-sm-center>
                    <v-flex>
                      <TextInput
                        name="emailToChange"
                        v-model="emailToChange"
                        :placeholderValue="this.$t('label.mail')"
                      />

                      <SubmitBtn
                        :colorCode="submitBtn.colorCode"
                        @click="postEmail"
                        :readonly="inEmailChangeProgress"
                        :autoSpread="true"
                        >{{ $t('label.postEmail') }}</SubmitBtn
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm12 md12> </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import EmailSigninForm from '@/components/molecules/EmailSigninForm.vue';
import Toolbar from '@/components/molecules/Toolbar.vue';
import { mapGetters, mapActions } from 'vuex';
import { Me, Auth } from '@/api';
import TokenManager from '@/utils/TokenManager';
import StorageManager from '@/utils/StorageManager';
import SubmitBtn from '@/components/atoms/SubmitBtn.vue';
import TextInput from '@/components/atoms/TextInput.vue';
import MaintenanceUtil from '@/utils/MaintenanceUtil';

export default {
  components: {
    EmailSigninForm,
    Toolbar,
    SubmitBtn,
    TextInput
  },
  data() {
    return {
      campaignCode: this.$route.params.campaignCode,
      temporaryToken: null,
      emailToChange: '',
      submitBtn: {
        colorCode: 'primary'
      },
      passwordChangeDialog: false,
      inEmailChangeProgress: false,
      isMaintenance: MaintenanceUtil.isMaintenance(),
      isMaintenanceSchedule: MaintenanceUtil.isMaintenanceSchedule(),
      maintenanceTerm: MaintenanceUtil.maintenanceTerm()
    };
  },
  computed: {
    ...mapGetters({ campaign: 'getCurrentCampaign' })
  },
  created() {
    /**
     * storeに認証情報がある場合はトップ画面へ遷移する
     * - 認証情報あり × campaignCodeが不正 = Codeの検証は遷移先にお任せ
     * - （認証情報なし × campaignCodeが不正 = このあとチェック）
     * - （認証情報なし × campaignCodeが正しい = ログイン画面を表示）
     */
    if (TokenManager.isLogin()) {
      this.$router.push('/cp/' + this.getCampaignCode() + '/me');
    } else {
      StorageManager.setItem('CAMPAIGN_CODE_SESSION_KEY', this.campaignCode);
      Auth.prepare({ campaignHash: this.campaignCode })
        .then(result => {
          this.setCurrentCampaign({
            ...result.data.campaign,
            code: this.campaignCode
          });
          this.temporaryToken = result.result.auth.token;
        })
        .catch(apiError => {
          // この画面でのエラーは意図的にURLを変更されたものなので全部404
          this.temporaryToken = apiError.data.result.auth.token;
          if (
            apiError.http.statusCode === 400 ||
            apiError.http.statusCode === 401 ||
            apiError.http.statusCode === 403 ||
            apiError.http.statusCode === 404
          ) {
            this.$router.push('/404');
          }
        });
    }
    // メンテナンスが予定されている場合は、メンテナンスフラグを常に更新する
    if (this.isMaintenanceSchedule) {
      setInterval(
        function() {
          this.isMaintenance = MaintenanceUtil.isMaintenance();
          this.isMaintenanceSchedule = MaintenanceUtil.isMaintenanceSchedule();
        }.bind(this),
        1000
      );
    }
  },
  methods: {
    ...mapActions(['prepareToSignin', 'login', 'setCurrentCampaign']),
    getCampaignCode: () => {
      return StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
    },
    signup(authInfo) {
      return this.login({ ...authInfo, temporaryToken: this.temporaryToken })
        .then(() => {
          this.$router.push(`/cp/${this.campaignCode}/me`);
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    postEmail() {
      this.inEmailChangeProgress = true;
      Me.initPassword(this.emailToChange, this.temporaryToken)
        .then(() => {
          this.inEmailChangeProgress = false;
          alert(
            'メールを送信しました。メールをご確認の上、記載されているURLにアクセス下さい。'
          );
          this.passwordChangeDialog = false;
        })
        .catch(ApiError => {
          let message = '';
          for (let error of ApiError.errors) {
            message += error.field + ' : ' + error.code + '\n';
          }
          alert(message);
        });
    }
  }
};
</script>

<style scoped lang="stylus">
.maintenance {
  width: 50%;
  z-index: 99999;
  background-color: rgba(0,0,0,0);
  text-align: center;
  padding: 8px;
  border: 1px solid #ff0000;
}
</style>
